import {useConfirm} from '@primer/react'
import {useCallback} from 'react'

import type {Project} from './types'

interface UseConfirmUnlinkProjectReturn {
  confirmUnlinkProject: (project: Project) => Promise<boolean>
}

export function useConfirmUnlinkProject(): UseConfirmUnlinkProjectReturn {
  const confirm = useConfirm()

  const confirmUnlinkProject = useCallback(
    (project: Project): Promise<boolean> => {
      const ownerText = project.projectOwnerIsOrganization ? `the ${project.owner} organization` : 'your account'
      return confirm({
        title: 'Unlink project?',
        content: `Unlinking "${project.title}" removes it from this repository. The project won't be deleted and will still be available to ${ownerText}.`,
        confirmButtonContent: 'Unlink project',
        cancelButtonContent: 'Cancel',
        confirmButtonType: 'danger',
      })
    },
    [confirm],
  )

  return {confirmUnlinkProject}
}
